import ReactDOM from 'react-dom'

import { SpecificChartFunctionality } from '../../main/constants'
import {
  ChartElementType,
  ChartLayout,
  Instrument,
  LayoutType,
  Quote,
  ScaleType,
  TIMEFRAME,
  Theme,
} from '../charts-lib'
import { getCustomColorsFromCookies } from '../shared/chartLayoutConfig'
import { parseJSONFromScript } from '../shared/parseJSONFromScript'
import { ready } from '../shared/ready'
import type { Indices } from './indices-data'
import { getData } from './indices-data'
import './market_sentiment'
import './refresh'
import SignalIntervalSwitch from './signals-switch'
import { HP_SIGNAL_SWITCH_RENDER_SELECTOR } from './signals-switch/types'

if (FinvizSettings.hasUserPremium || FinvizSettings.hasRedesignEnabled) {
  import(/* webpackChunkName: "recent_quotes" */ '../shared/recent_quotes').then(({ RenderRecentQuotes }) => {
    RenderRecentQuotes()
  })
}

function getChartConfig(ticker: string) {
  return {
    layout: LayoutType['1h1v'],
    width: 320,
    height: 190,
    barWidth: 3,
    barMargin: 1,
    scrollable: false,
    editable: false,
    cross: false,
    colors: getCustomColorsFromCookies(),
    specificChartFunctionality: SpecificChartFunctionality.smallIndex,
    theme: FinvizSettings.hasDarkTheme ? Theme.dark : Theme.light,
    charts: [
      {
        width: 0,
        premarket: false,
        aftermarket: false,
        dateRange: null,
        height: 190,
        timeframe: TIMEFRAME.i10,
        scale: ScaleType.Linear,
        ticker: ticker,
        // leftOffset: 0,
        instrument: Instrument.Stock,
        refreshData: false,
        // stretch: true,
        panes: [
          {
            height: 190,
            elements: [
              {
                type: ChartElementType.CandleStick,
                overlays: [],
              },
            ],
          },
        ],
      },
    ],
  }
}

function renderChart({ ticker, element }: { ticker: string; element: HTMLElement | null }) {
  if (element) {
    ReactDOM.render(
      <div className="hp_chart-wrapper">
        <ChartLayout config={getChartConfig(ticker)} />
      </div>,
      element
    )
  }
}

function renderSignalIntervalSwitch() {
  const signalSwitches = document.getElementById(HP_SIGNAL_SWITCH_RENDER_SELECTOR)

  if (signalSwitches) {
    ReactDOM.render(<SignalIntervalSwitch />, signalSwitches)
  }
}

ready(function () {
  const indices = parseJSONFromScript<Indices>('js-indices')!

  Quote.create(getData('^DJI', 'DOW', indices)).save()
  Quote.create(getData('^IXIC', 'NASDAQ', indices)).save()
  Quote.create(getData('^GSPC', 'S&P 500', indices)).save()
  Quote.create(getData('^RUT', 'RUSSELL 2000', indices)).save()

  renderChart({ ticker: 'DOW', element: document.getElementById('dow') })
  renderChart({ ticker: 'NASDAQ', element: document.getElementById('nasdaq') })
  renderChart({ ticker: 'S&P 500', element: document.getElementById('sp500') })
  renderChart({ ticker: 'RUSSELL 2000', element: document.getElementById('rut') })

  renderSignalIntervalSwitch()
})
